import React from "react";
import PropTypes from "prop-types";
import { Send } from "lucide-react";

const ChatInput = ({
   message = "",
  setMessage,
  sendMessage,
  isTyping,
  textareaRef,
  handleKeyPress,
}) => {
  return (
    <div className="bg-white border-t border-gray-200 px-4 py-1 flex-shrink-0 sticky bottom-0 z-10">
      <div className="max-w-4xl mx-auto">
        <div className="relative flex items-center">
          <textarea
            ref={textareaRef}
            value={message || ""} // Add fallback for undefined message 
            onChange={(e) => setMessage?.(e.target.value)} // Add optional chaining
            onKeyPress={handleKeyPress}
            placeholder="Type your message..."
            className="w-full pr-12 pl-4 py-3 border border-gray-300 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            rows="1"
            style={{ minHeight: "48px", maxHeight: "120px" }}
          />
          <button
            onClick={sendMessage}
            disabled={!message?.trim() || isTyping}
            className={`absolute right-3 p-2 rounded-md transition-colors ${
              message.trim() && !isTyping
                ? "text-blue-500 hover:text-blue-600"
                : "text-gray-400 cursor-not-allowed"
            }`}
          >
            <Send className="w-5 h-5" />
          </button>
        </div>

        <p className="text-xs text-gray-500 text-center">
          Press Enter to send, Shift + Enter for new line
        </p>
      </div>
    </div>
  );
};

ChatInput.propTypes = {
  message: PropTypes.string,
  setMessage: PropTypes.func.isRequired,
  sendMessage: PropTypes.func.isRequired,
  isTyping: PropTypes.bool.isRequired,
  textareaRef: PropTypes.object,
  handleKeyPress: PropTypes.func.isRequired,
};

export default ChatInput;